/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb25Inputs */

const en__field_enum_pbs_fb25 = /** @type {(inputs: _Field_Enum_Pbs_Fb25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 02 Faculty of Economics and Business `)
};

const de__field_enum_pbs_fb25 = /** @type {(inputs: _Field_Enum_Pbs_Fb25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 02 Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "F 02 Faculty of Economics and Business" |
*
* @param {_Field_Enum_Pbs_Fb25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb25 = /** @type {((inputs?: _Field_Enum_Pbs_Fb25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb25(inputs)
	return de__field_enum_pbs_fb25(inputs)
});
export { _field_enum_pbs_fb25 as "_field_enum_PBS_FB2" }